module.exports = "\n  <ion-content>\n  \n</ion-content>"